import {
  AppBar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import { useState } from "react";
import Logo from "../../assets/landing_page/Planshare.png";

export const LandingPageNav = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      position='static'
      sx={{ background: "#fff", boxShadow: 0, color: "#000", py: 0.5 }}>
      <Toolbar>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}>
          {"/" === window.location.pathname ? (
            <ScrollLink
              to='main'
              spy={true}
              smooth={true}
              offset={-70}
              duration={900}
              style={{
                cursor: "pointer",
                color: "inherit",
                textDecoration: "none",
              }}>
                <img
                src={Logo}
                alt='planshare logo'
                style={{ width: "140px", height: "32px" }}
              />
            </ScrollLink>
          ) : (
            <RouterLink to={"/"} style={{ textDecoration: "none" }}>
              <img
                src={Logo}
                alt='planshare logo'
              />
            </RouterLink>
          )}
          <Box sx={{ display: { xs: "none", lg: "flex" }, flexWrap: "nowrap" }}>
            {navDatas.map((e, i) =>
              e.link === "/" ? (
                <ScrollLink
                  key={i}
                  to={e.to}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  style={{
                    cursor: "pointer",
                    color: "inherit",
                    textDecoration: "none",
                  }}>
                  <Button
                    disableTouchRipple
                    sx={{
                      color: "inherit",
                      flexWrap: "nowrap",
                      mx: "3px",
                      fontStyle: "normal",
                      textTransform: "capitalize",
                    }}>
                    {e.title}
                  </Button>
                </ScrollLink>
              ) : (
                <RouterLink
                  key={i}
                  to={e.to}
                  style={{ textDecoration: "none" }}>
                  <Button
                    sx={{
                      color: "inherit",
                      flexWrap: "nowrap",
                      mx: "3px",
                      fontStyle: "normal",
                      textTransform: "capitalize",
                    }}>
                    {e.title}
                  </Button>
                </RouterLink>
              )
            )}
          </Box>
          <Box sx={{ display: { xs: "none", md: "flex" }, flexWrap: "nowrap" }}>
            <RouterLink to='/Login' style={{ textDecoration: "none" }}>
              <Button
                disableRipple
                sx={{
                  color: "#040815",
                  fontWeight: "500",
                  fontSize: "18px",
                  mx: "10px",
                  textTransform: "capitalize",
                  px: 3,
                }}>
                Sign In
              </Button>
            </RouterLink>
            <RouterLink to='/Reg' style={{ textDecoration: "none" }}>
              <Button
                sx={{
                  color: "#fff",
                  background: "#FF2800",
                  mx: "10px",
                  textTransform: "capitalize",
                  "&:hover": { background: "#FF280099" },
                  px: 3,
                }}>
                Get Started
              </Button>
            </RouterLink>
          </Box>
        </Box>
        <IconButton
          edge='start'
          color='#000'
          aria-label='menu'
          sx={{ display: { xs: "block", md: "none" } }}
          onClick={handleMenuOpen}>
          <MenuIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          sx={{ display: { xs: "block", md: "none" } }}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}>
          {navDatas.map((item, index) =>
            item.link === "/" ? (
              <ScrollLink
                key={index}
                to={item.to}
                spy={true}
                smooth={true}
                offset={-70}
                duration={900}
                style={{
                  cursor: "pointer",
                  color: "inherit",
                  textDecoration: "none",
                  textTransform: "capitalize",
                }}>
                <MenuItem
                  onClick={handleMenuClose}
                  sx={{ px: 3, color: "#000" }}>
                  {item.title}
                </MenuItem>
              </ScrollLink>
            ) : (
              <RouterLink
                key={index}
                to={item.link}
                style={{ textDecoration: "none" }}>
                <MenuItem
                  onClick={handleMenuClose}
                  sx={{ px: 3, color: "#000" }}>
                  {item.title}
                </MenuItem>
              </RouterLink>
            )
          )}
          <RouterLink to='/Login' style={{ textDecoration: "none" }}>
            <MenuItem onClick={handleMenuClose} sx={{ px: 3, color: "#000" }}>
              Sign In
            </MenuItem>
          </RouterLink>
          <RouterLink to='/Reg' style={{ textDecoration: "none" }}>
            <MenuItem onClick={handleMenuClose} sx={{ px: 3, color: "#000" }}>
              Get Started
            </MenuItem>
          </RouterLink>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

const navDatas = [
  {
    title: "Home",
    link: "/",
    to: "FirstPage",
  },
  {
    title: "Demo",
    link: "/",
    to: "SecondPage",
  },
  {
    title: "Features",
    link: "/",
    to: "ThirdPage",
  },
  {
    title: "Benefits",
    link: "/",
    to: "FourthPage",
  },
  {
    title: "Pricing",
    link: "/",
    to: "FifthPage",
  },
  {
    title: "Social Proof",
    link: "/",
    to: "SixthPage",
  },
  {
    title: "FAQ",
    link: "/",
    to: "SeventhPage",
  },
  {
    title: "Blog",
    link: "/",
    to: "",
  },
];
